"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProfileLinkShareMenuItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Link = _interopRequireDefault(require("@kyruus/react-ikons/Link"));
var _style = require("./style");
const ProfileLinkShareMenuItem = _ref => {
  let {
    url,
    showLabel,
    label,
    onProfileLinkClick,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_style.StyledMenuItem, (0, _extends2.default)({}, props, {
    onClick: () => {
      onProfileLinkClick(url);
    }
  }), /*#__PURE__*/_react.default.createElement(_Link.default, {
    size: _style.ICON_HEIGHT,
    "aria-hidden": "true",
    title: "",
    "data-testid": "profile-link-svg"
  }), showLabel ? /*#__PURE__*/_react.default.createElement(_style.StyledLabel, null, label) : null);
};
exports.ProfileLinkShareMenuItem = ProfileLinkShareMenuItem;
ProfileLinkShareMenuItem.propTypes = {
  /**
   * The url of the page you want to share.
   */
  url: _propTypes.default.string.isRequired,
  /**
   * Whether to show the 'Email' label or not
   */
  showLabel: _propTypes.default.bool,
  /**
   * Label content
   */
  label: _propTypes.default.node,
  /**
   * Called before the the onClick is executed for the link.
   */
  onProfileLinkClick: _propTypes.default.func
};
var _default = exports.default = ProfileLinkShareMenuItem;
ProfileLinkShareMenuItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProfileLinkShareMenuItem",
  "props": {
    "url": {
      "description": "The url of the page you want to share.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "showLabel": {
      "description": "Whether to show the 'Email' label or not",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "label": {
      "description": "Label content",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "onProfileLinkClick": {
      "description": "Called before the the onClick is executed for the link.",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};